export default __webpack_public_path__ + "static/media/Web_Track.e7eb9635.svg";